import { useHistory, useLocation } from 'react-router-dom';
import Container from '~/components/container';
import * as St from '../Detail/styles';
import ContainerFlex from '~/components/containerFlex';
import TitleApp from '~/components/title';
import moment from 'moment';
import useApi from '~/hooks/useApi';
import Loading from '~/components/loading';
import Button from '~/components/button';
import Endpoints from '~/services/endpoints';

export default function InvoiceExtract() {
  const history = useHistory();
  const { state } = useLocation<{
    numeroCartao: string;
    dataReferencia: string;
    fatura: any;
    faturaFutura: boolean;
  }>();

  const fatura = state?.fatura || {};
  const extratoFatura = useApi({
    url: Endpoints.consult.getClientInvoiceExtract,
    enabled: !!state?.numeroCartao && !!state?.dataReferencia,
    body: {
      numeroCartao: state?.numeroCartao?.replaceAll('.', ''),
      dataReferencia: state?.dataReferencia
    },
  });
  const extrato = extratoFatura?.data?.data || [];
  const dataVencimento = fatura?.dataVencimento || fatura?.dtVencimento;

  return (
    <div>
      <Loading status={extratoFatura.loading} />
      <Container>
        <St.BoxCard>
          <ContainerFlex>
            <ContainerFlex padding={18} style={{ background: '#FBFBFB' }}>
              <ContainerFlex row marginBottom={12} space>
                <St.TitleCategoryExtract>
                  Fatura{' '}
                  {moment(dataVencimento ?? fatura.periodo, 'yyyy-MM')
                    .toDate()
                    .toLocaleString('pt-BR', {
                      month: 'long',
                    })}
                </St.TitleCategoryExtract>
                <St.TitleCategoryExtract>
                  Vencimento:{' '}
                  {moment(dataVencimento).format('DD/MM/YYYY')}
                </St.TitleCategoryExtract>
              </ContainerFlex>
              {!state?.faturaFutura && (
                <ContainerFlex space>
                  <St.TitleCategoryExtract>
                    Valor total: R$ {fatura?.valorTotalFatura?.toFixed(2)}
                  </St.TitleCategoryExtract>
                  <St.TitleCategoryExtract>
                    Valor mínimo: R$ {fatura?.valorMinimoFatura?.toFixed(2)}
                  </St.TitleCategoryExtract>
                </ContainerFlex>
              )}
            </ContainerFlex>
          </ContainerFlex>
          <ContainerFlex>
            {extrato?.toReversed()?.map((fatura, index) => (
              <St.InvoiceGridList key={index}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                  }}
                >
                  <span>
                    {fatura?.parcelas > 1
                      ? fatura?.descricao?.replace(/\s\d+\/\d+$/, '')
                      : fatura?.descricao}
                    {fatura?.parcelas > 1
                      ? ` - Parcela ${fatura?.parcela}/${fatura?.parcelas}`
                      : ''}
                  </span>
                  <span>
                    {moment(fatura?.dtInclusao)
                      .toDate()
                      .toLocaleString('pt-BR', {
                        month: 'long',
                        day: '2-digit',
                        year: 'numeric',
                      })
                      .toUpperCase()}
                  </span>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <span>{fatura?.nomeEstabelecimento || ''}</span>
                  <span>{fatura?.debitoCredito === "CREDITO"? "-": " "} R$: {fatura.valor.toFixed(2)}</span>
                  
                </div>
                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end'}}>
                  {fatura?.parcelas > 1 && <span>{`Parcela ${fatura?.parcela} de ${fatura?.parcelas}`}</span>}
                </div>
              </St.InvoiceGridList>
            ))}
          </ContainerFlex>

          <ContainerFlex marginTop={24} padding={16}>
            <Button fitContent onClick={() => history.goBack()}>
              Voltar
            </Button>
          </ContainerFlex>
        </St.BoxCard>
      </Container>
    </div>
  );
}
